/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";

// import theme from "../config/theme";

const ToolbarButton = props => {
  const {
    active,
    vertical,
    dark,
    tooltip,
    placement,
    children,
    loading,
    width = 52
  } = props;
  let bgColor = "none";

  let { height } = props;

  if (!height) {
    height = vertical ? 56 : 48;
  }

  if (dark) {
    if (active) {
      bgColor = "#3b3b3b";
    } else {
      bgColor = "#262626";
    }
  }

  const hoverBg = dark ? "#fff3" : "#0001";

  const styles = css`
    background: ${bgColor};
    height: ${height}px;
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    min-width: ${width}px;
    color: ${dark ? "white" : "#565656"};
    > p {
      color: ${dark ? "white" : "#3b3b3b"};
      font-size: 0.775rem;
      z-index: 1;
    }
    > svg {
      z-index: 1;
      width: ${tooltip ? 27 : 27}px;
      height: ${tooltip ? 27 : 27}px;
    }
    :hover {
      background: ${hoverBg};
    }
  `;

  if (tooltip) {
    return (
      <Tooltip title={props.desc} placement={placement}>
        <ButtonBase css={styles} onClick={props.onClick}>
          {loading ? <CircularProgress color="secondary" /> : props.icon}
          {children}
        </ButtonBase>
      </Tooltip>
    );
  } else {
    return (
      <ButtonBase css={styles} onClick={props.onClick}>
        {loading ? (
          <CircularProgress size={30} color="secondary" />
        ) : (
          props.icon
        )}
        <Typography>{props.desc}</Typography>
        {children}
      </ButtonBase>
    );
  }
};

export default ToolbarButton;
